module.exports = __webpack_public_path__ + "img/Poll.1f819ed8.jpg";